import { render } from "./UserRoles.vue?vue&type=template&id=2bc08726&ts=true"
import script from "./UserRoles.vue?vue&type=script&lang=ts"
export * from "./UserRoles.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__